const light = {
	50: '#edf7ff',
	100: '#d6ecff',
	200: '#bfe1ff',
	300: '#8ccaff',
	400: '#63b5fd',
	500: '#3da9fc', // base color
	600: '#369ae6',
	700: '#2e87cc',
	800: '#2674b3',
	900: '#1e5f99',
	A100: '#ffffff',
	A200: '#f5fbff',
	A400: '#b3dcff',
	A700: '#7fc4ff'
};

export default light;
